import { useTranslation } from 'react-i18next';

export function useLang(): 'it' | 'en' {
  const { i18n } = useTranslation();
  const code = (i18n.resolvedLanguage ?? i18n.language).slice(0, 2);
  return code === 'en' ? 'en' : 'it';
}
